function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    var location = useLocation();
    var navigate = useNavigate();
    var params = useParams();
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      location: location,
      navigate: navigate,
      match: {
        params: params
      }
    }));
  }
  return ComponentWithRouterProp;
}
export default withRouter;